var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center lg:hidden"},[_c('TappinButton',{staticClass:"button-secondary transition-all duration-200 font-bold px-10 py-2 rounded-full",attrs:{"aria-label":"go to top of lobby","custom_caption":_vm.options.mainStageCaption},on:{"click":_vm.goToMainStage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }